import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/report/SafeDrivingScoreDetails/.eu';

export interface SafeDrivingScoreDetailsProps {
  vin: string;
  selectedMonth: string;
}

export default function SafeDrivingScoreDetails({vin, selectedMonth}: SafeDrivingScoreDetailsProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu
            vin={vin}
            selectedMonth={selectedMonth}
          />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
